var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgConfirmNotificationIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.43,56.85a.51.51,0,0,0-.37-.85H25.4a.51.51,0,0,0-.37.85,9.81,9.81,0,0,0,14.4,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.51,46.77A22.13,22.13,0,0,1,52.2,31.05l.07-6.31C52.38,13.87,44,4.5,33.18,4a20,20,0,0,0-20.9,19.76l-.07,6.83A22.13,22.13,0,0,1,5.55,46.19l-.82.8A2.42,2.42,0,0,0,4,48.7v.57a2.42,2.42,0,0,0,2.4,2.45l51.15.55A2.42,2.42,0,0,0,60,49.88v-.57a2.42,2.42,0,0,0-.69-1.72ZM42.24,26.82l-8.7,8.52a5.5,5.5,0,0,1-7.76-.06l-3.45-3.49a2.38,2.38,0,0,1,0-3.36l.89-.87a2.38,2.38,0,0,1,3.36,0L28,29a2.38,2.38,0,0,0,3.36,0L38,22.53a2.38,2.38,0,0,1,3.36,0l.87.89A2.38,2.38,0,0,1,42.24,26.82Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConfirmNotificationIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ConfirmNotificationIcon.15fe62fe.svg";
export { ForwardRef as ReactComponent };